import { getDefaultRecommendationSettings } from "./recommendationSettings.js";
//todo: remove all hardcoded values
export function getDuration(motifs, patient, dureeMiniRdv, forcedDuration, profile = getDefaultRecommendationSettings().durationProfiles.cadenweb) {
    if (forcedDuration !== undefined) {
        return forcedDuration; // Return the forced duration if provided
    }
    if (profile.newPatientAdult.enabled &&
        patient.isNewPatient &&
        patient.age > profile.newPatientMinor.maxAge) {
        return profile.newPatientAdult.duration;
    }
    if (profile.newPatientMinor.enabled &&
        patient.isNewPatient &&
        patient.age <= profile.newPatientMinor.maxAge) {
        return profile.newPatientMinor.duration;
    }
    if (profile.shortMotifs.enabled &&
        motifs.filter((motif) => !profile.shortMotifs.motifs.includes(motif))
            .length === 0) {
        return profile.shortMotifs.duration;
    }
    if (profile.brokenTooth.enabled &&
        motifs.includes(profile.brokenTooth.motif)) {
        return profile.brokenTooth.duration;
    }
    return dureeMiniRdv;
}
//# sourceMappingURL=getDuration.js.map